function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.17156 0.228764C0.911215 -0.0315853 0.489105 -0.0315857 0.228755 0.228764C-0.0315941 0.489114 -0.031594 0.911223 0.228755 1.17157L3.05718 4L0.228755 6.82843C-0.0315946 7.08878 -0.0315944 7.51089 0.228755 7.77124C0.489105 8.03159 0.911214 8.03159 1.17156 7.77124L3.99999 4.94281L6.82842 7.77124C7.08877 8.03159 7.51088 8.03159 7.77123 7.77124C8.03158 7.51089 8.03158 7.08878 7.77123 6.82843L4.9428 4L7.77123 1.17157C8.03158 0.911223 8.03158 0.489114 7.77123 0.228764C7.51088 -0.0315854 7.08877 -0.0315857 6.82842 0.228764L3.99999 3.05719L1.17156 0.228764Z"
});

function SvgCrossIconSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "#908E8E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconSm);
export default __webpack_public_path__ + "static/media/cross-icon-sm.ac9f6968.svg";
export { ForwardRef as ReactComponent };